import { type FC, type LazyExoticComponent, lazy } from "react"

const CoachDashboardDataPanelEntity: LazyExoticComponent<FC> = lazy(
    (): Promise<{ default: FC }> => import("./coach.dashboard.data-panel.entity")
)

export default CoachDashboardDataPanelEntity
